import { useToast } from "@circleco/compass/context/CompassContext";

export const useConversationActionsToast = () => {
  const toast = useToast();

  return {
    success: (title: string) =>
      toast.add({
        title,
        variant: "primary",
        icon: "circle-check-filled",
        iconColor: "success",
        "data-testid": "conversation-action-toast",
      }),
    error: (title: string) =>
      toast.add({
        title,
        variant: "destructive",
        icon: "triangle-exclamation-filled",
        iconColor: "danger",
        "data-testid": "conversation-action-toast",
      }),
  };
};
